export default __webpack_public_path__ + "static/media/qr.c9ae14f4.png";